<template>
  <div class="row">
    <div class="col-12">
      <div class="form-item">
        <label class="form-item__label info-popup">
          {{ $t("platform.settings.pop.pop_type") }}

          <svg
            v-svg
            v-tooltip="{
              content: $t('platform.settings.description.onclick.pop_type'),
              triggers: ['hover', 'click'],
            }"
            symbol="info"
            size="0 0 18 18"
            role="info"
          ></svg>
        </label>
        <custom-multiselect v-model="pop_type" :disabled="true" :list="pop_type_options" class="multiselect-wrapper form-item__field" :allowEmpty="false">
          <template v-slot:block="props">
            <span>{{ $t(`platform.settings.pop.pop_types.${props.value.title}`) }}</span>
          </template>
          <template v-slot:list="props">
            <span>{{ $t(`platform.settings.pop.pop_types.${props.value.title}`) }}</span>
          </template>
        </custom-multiselect>
        <div class="warn-block mt-2" v-if="pop_type.title === 'new_tab_left_with_redirect'">
          <svg class="icon" v-svg symbol="info" size="0 0 17 17" role="info"></svg>
          <p>
            {{ $t("platform.settings.pop.redirect_warn") }}
          </p>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="form-item">
        <div class="form-item__label info-popup">
          {{ $t("platform.settings.pop.selector") }}

          <svg
            v-svg
            v-tooltip="{
              content: $t('platform.settings.description.onclick.selector'),
              triggers: ['hover', 'click'],
            }"
            symbol="info"
            size="0 0 18 18"
            role="info"
          ></svg>
        </div>
        <div class="form-item__field">
          <input type="text" v-model.trim="selector" :disabled="true" />
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-6 col-md-4 form-input-wrapper">
      <Counter v-model="display_frequency" :disabled="true" :max="10" :min="1" :title="'platform.settings.pop.display_frequency'" :description="'platform.settings.description.onclick.display_frequency'" />
    </div>
    <div class="col-12 col-sm-6 col-md-4 form-input-wrapper">
      <Counter v-model="period" :disabled="true" :max="period_time_unit && period_time_unit.id === 3 ? 48 : 60" :min="0" :title="'platform.settings.pop.period'" :description="'platform.settings.description.onclick.period'" />
    </div>
    <div class="col-12 col-sm-12 col-md-4 form-input-wrapper">
      <div class="form-item">
        <label class="form-item__label info-popup">
          {{ $t("platform.settings.pop.time_unit") }}

          <svg
            v-svg
            v-tooltip="{
              content: $t('platform.settings.description.onclick.time_units_period'),
              triggers: ['hover', 'click'],
            }"
            symbol="info"
            size="0 0 18 18"
            role="info"
          ></svg>
        </label>
        <custom-multiselect v-model="period_time_unit" :list="period_unit_options" :disabled="true" class="multiselect-wrapper multiselect-w-100 form-item__field" :allowEmpty="false">
          <template v-slot:block="props">
            <span>{{ $t(`platform.settings.pop.time_units.${props.value.title}`) }}</span>
          </template>
          <template v-slot:list="props">
            <span>{{ $t(`platform.settings.pop.time_units.${props.value.title}`) }}</span>
          </template>
        </custom-multiselect>
      </div>
    </div>

    <div class="col-12 mb-4 pt-4">
      <h3>{{ $t("platform.settings.pop.click_condition") }}</h3>
    </div>
    <div class="col-12 col-md-6">
      <Counter v-model="interval" :disabled="true" :max="60" :min="0" :title="'platform.settings.pop.interval'" :description="'platform.settings.description.onclick.interval'" />
    </div>
    <div class="col-12 col-md-6">
      <div class="form-item">
        <label class="form-item__label info-popup">
          {{ $t("platform.settings.pop.time_unit") }}

          <svg
            v-svg
            v-tooltip="{
              content: $t('platform.settings.description.onclick.time_units_interval'),
              triggers: ['hover', 'click'],
            }"
            symbol="info"
            size="0 0 18 18"
            role="info"
          ></svg>
        </label>
        <custom-multiselect v-model="interval_time_unit" :disabled="true" :list="interval_unit_options" class="multiselect-wrapper multiselect-w-100 form-item__field" :allowEmpty="false">
          <template v-slot:block="props">
            <span>
              {{ $t(`platform.settings.pop.time_units.${props.value.title}`) }}
            </span>
          </template>
          <template v-slot:list="props">
            <span>
              {{ $t(`platform.settings.pop.time_units.${props.value.title}`) }}
            </span>
          </template>
        </custom-multiselect>
      </div>
    </div>
    <div class="col-12">
      <div class="form-item">
        <label class="form-item__label">
          {{ $t("platform.settings.pop.min_clicks_title") }}
        </label>
        <custom-multiselect v-model="min_clicks" :disabled="true" :list="min_clicks_list" class="multiselect-wrapper multiselect-w-100 form-item__field" :allowEmpty="false">
          <template v-slot:block="props">
            <span>{{ $formatLabel(props.value.title) }}</span>
          </template>
          <template v-slot:list="props">
            <span>{{ $formatLabel(props.value.title) }}</span>
          </template>
        </custom-multiselect>
      </div>
    </div>
  </div>
</template>

<script>
import Counter from "@/components/PlatformSettings/Counter.vue";

export default {
  name: "OnClick",
  props: {
    platform: {
      type: Object,
    },
  },
  components: {
    Counter,
  },
  data() {
    return {
      display_frequency: 1,
      selector: "",
      pop_type: { id: 1, title: "new_tab" },
      pop_type_options: [
        { id: 1, title: "new_tab" },
        { id: 2, title: "new_tab_left" },
        { id: 3, title: "new_tab_left_with_redirect" },
        { id: 4, title: "replace" },
        { id: 5, title: "popup" },
      ],
      interval: 0,
      interval_time_unit: { id: 1, title: "seconds", value: 1 },
      interval_unit_options: [
        { id: 1, title: "seconds", value: 1 },
        { id: 2, title: "minutes", value: 60 },
      ],
      period: 0,
      period_time_unit: { id: 1, title: "seconds", value: 1 },
      period_unit_options: [
        { id: 1, title: "seconds", value: 1 },
        { id: 2, title: "minutes", value: 60 },
        { id: 3, title: "hours", value: 3600 },
      ],
      min_clicks: { title: "platform.settings.pop.min_clicks.one", value: 1 },
      min_clicks_list: [
        { title: "platform.settings.pop.min_clicks.one", value: 1 },
        { title: "platform.settings.pop.min_clicks.two", value: 2 },
        { title: "platform.settings.pop.min_clicks.three", value: 3 },
        { title: "platform.settings.pop.min_clicks.four", value: 4 },
        { title: "platform.settings.pop.min_clicks.five", value: 5 },
        { title: "platform.settings.pop.min_clicks.six", value: 6 },
        { title: "platform.settings.pop.min_clicks.seven", value: 7 },
        { title: "platform.settings.pop.min_clicks.eight", value: 8 },
        { title: "platform.settings.pop.min_clicks.nine", value: 9 },
        { title: "platform.settings.pop.min_clicks.ten", value: 10 },
      ],
      displaySettings: {
        disableDeviceSell: "",
        disableOsSell: "",
        notShowReff: false,
        disableYandex: false,
        linkOnly: false,
      },
      osVersions: [],
    };
  },
};
</script>
